import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";

import { useMemo, useCallback } from "react";
import { Button, Form } from "react-bootstrap";
import moment from "moment";
import { useFormik } from "formik";
import { DateRangePicker } from "rsuite";
import { BiSearch } from "react-icons/bi";
import { Stack } from 'rsuite';
import subDays from 'date-fns/subDays';
import startOfWeek from 'date-fns/startOfWeek';
import endOfWeek from 'date-fns/endOfWeek';
import addDays from 'date-fns/addDays';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';
import addMonths from 'date-fns/addMonths';
import Sidebar from "../../includes/Sidebar";
import { QaErrorReportService } from "../../../services/QaErrorReportService";
import QaErrorReportDetails from "./QaErrorReportDetails";
import { BsCloudDownloadFill } from "react-icons/bs";
import { downloadXl, predefinedBottomRanges } from "../../../functions";
import { useDispatch, useSelector } from "react-redux";
import { selectIsSuperUser, selectPermissions } from "../../../slice/user/userSlice";
import { Tooltip } from "@mui/material";
import { seErrorMessage } from "../../../slice/error/errorSlice";
import { DataListService } from "../../../services/DataListService";
import Select, { components } from 'react-select';
import { TbGridDots } from "react-icons/tb";
import { HiChevronDown } from "react-icons/hi";
import AsyncSelect from 'react-select/async';
import { InvoiceReportService } from "../../../services/InvoiceReportService";
import DownloadDropDown from "../../components/DownloadDropDown";
import SingleSelect from "../../components/SingleSelect";
import { getUnmatchedKeys } from "../../../utils/objectUtils";
import FilterUnMatchModal from "../../../utils/modal";



const datatableCustomStyles = {
  rows: {
    style: {
      minHeight: '20px', // override the row height
      fontSize: '0.7em',
      fontColor: '#212529 !important',
      width: '100%'
    },
  },
  headCells: {
    style: {
      paddingLeft: '5px', // override the cell padding for head cells
      paddingRight: '5px',
      textTransform: "uppercase",
      fontSize: '0.7em',
      fontWeight: '800',
      fontColor: '#6c757d !important',
      opacity: 1,
      minHeight: "10px",
    },
  },
  cells: {
    style: {
      paddingLeft: '8px', // override the cell padding for data cells
      paddingRight: '8px',
      width: "100%",
    },
  },
  pagination: {
    style: {
      color: '#000',
      fontSize: '13px',
      minHeight: '56px',
      backgroundColor: '#fff',
      borderTopStyle: 'solid',
      borderTopWidth: '1px',
      borderTopColor: '#f2f2f2',
    },
    pageButtonsStyle: {
      borderRadius: '50%',
      height: '40px',
      width: '40px',
      padding: '8px',
      margin: '0px',
      cursor: 'pointer',
      transition: '0.4s',
      color: '#000',
      fill: '#000',
      backgroundColor: 'transparent',
      '&:disabled': {
        cursor: 'unset',
        color: '#e2e2e2',
        fill: '#e2e2e2',
      },
      '&:hover:not(:disabled)': {
        backgroundColor: '#f2f2f2',
      },
      '&:focus': {
        outline: 'none',
        backgroundColor: '#f5f5f5',
      },
    },
  },
};

function QaErrorReport() {
  const dispatch = useDispatch()
  const facilityRef = useRef(null)
  const clientRef = useRef(null)

  const [reRenderDataTable, setRerenderDataTable] = useState(false)
  const [pageno, setPageNo] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isTimeCount, setisTimeCount] = useState(false);
  const [totalRows, setTotalRows] = useState(100);
  const [filterText, setFilterText] = useState('');
  const [colorRow, setColorRow] = React.useState({});
  const [data, setData] = useState({})
  const [limit, setLimit] = useState(100)
  const [searchedData, setSearchedData] = useState({
    station: "",
    date_range: `${moment(startOfMonth(new Date())).format('MM/DD/YYYY HH:mm:ss')} - ${moment(new Date()).format('MM/DD/YYYY HH:mm:ss')}`,
    created_date: "",
    hour_count: "",
    users_ids: [],
    clients: [],
    facilities: [],
    partners: [],

  })
  const [isFocusedClient, setIsFocusedClient] = useState(false);

  const [clients, setClients] = useState([]);

  const [isFocusedFacility, setIsFocusedFacility] = useState(false);

  const [selectValue, setSelectValue] = useState([])

  const [facilities, setFacilities] = useState([])

  const [selectIds, setSelectIds] = useState("")

  const [selectedFacility, setSelectedFacility] = useState([])

  const [selectedFacilityIds, setSelectedFacilityIds] = useState("")

  const [selectedPartner, setSelectedPartner] = useState([])
  const [partners, setPartners] = useState([])
  const [fullClients, setFullClients] = useState([])
  const [isFocusedPartner, setIsFocusedPartner] = useState(false);
  const [isInitSearch,setIsInitSearch] = useState(true)

  const [unmatchFilterModalShow, setUnmatchFilterModalShow] = useState(false);

  const handleModalClose = () => setUnmatchFilterModalShow(false);
  const handleModalShow = () => setUnmatchFilterModalShow(true);


  const invoiceReportService = new InvoiceReportService();

  const { getFacilityDropdown, getClientPartnerDropdown, getPartnerDropdown } = invoiceReportService
  const qaErrorReportService = new QaErrorReportService();
  const dataListService = new DataListService();

  const { getQaErrorReportSummery, downloadQaErrorReportSummery, downloadQaErrorFieldReport, downloadQaErrorReportSingle, downloadQualityReport } = qaErrorReportService
  const { getUserlist } = dataListService

  const permissions = useSelector(selectPermissions);
  const isSuperUser = useSelector(selectIsSuperUser);
  const isHavePermission = (name) => {
    return permissions?.includes(name) || isSuperUser
  }
  const station_option = [
    { value: "", label: "My Work" },
    { value: 2, label: "QA Review" },
  ]
  const handlePerRowsChange = async (newPerPage, page) => {


    setLimit(newPerPage);
    setPageNo(1)
    fetchData(1, newPerPage, searchedData?.station, searchedData?.station, searchedData?.date_range ?? "", searchedData?.hour_count, searchedData.users_ids, searchedData?.clients, searchedData.facilities, searchedData?.partners);

    handleResetDataTable()

  };

  const handlePageChange = page => {
    setPageNo(page)
    fetchData(page, limit, searchedData?.station, searchedData?.station, searchedData?.date_range ?? "", searchedData?.hour_count, searchedData.users_ids, searchedData?.clients, searchedData.facilities, searchedData?.partners);
  };

  const fetchData = (page, limit, station, job_status, date_range, hour_count, users_ids, clients, facilities, partners) => {
    setLoading(true)
    setisTimeCount(hour_count == 'true' || hour_count == '' ? false : true)
    getQaErrorReportSummery(page, limit, station, job_status, date_range, hour_count, users_ids, clients, facilities, partners).then((response) => {
      setData(response?.data);
      setLimit(limit);
      setPageNo(page)
      setTotalRows(response?.data?.count);
      setLoading(false);
      if (response?.errors?.date_range) {
        dispatch(seErrorMessage({ message: response?.errors?.date_range[0], is_show: true }))
      }
    });

  }

  const handleRowClickCheck = (row) => {
    data?.results.map((item, index) => {
      if (row?.id == item.id) {
        setColorRow(row)
      }
    })
  }
  const [expandedRows, setExpandedRows] = useState([]);
  const ExpandedComponent = useCallback(
    ({ data }) => (
      <pre>
        {expandedRows?.length > 0 && (
          <QaErrorReportDetails
            report_page={1}
            report_limit={limit}
            report_station={searchedData?.station}
            report_job_status={""}
            report_date_range={searchedData?.date_range}
            report_hour_count={searchedData?.hour_count}
            clients={searchedData?.clients}
            facilities={searchedData?.facilities}
            partners={searchedData?.partners}
            user={data.user_id}
            client_id={data.client_id}
            facility_id={data.facility_id}
            partner_id={data.partner_id}
          />
        )}
      </pre>
    ),
    [expandedRows, limit, searchedData]
  );
  // const ExpandedComponent = (row) => <pre>{expandedRows?.length > 0 && <QaErrorReportDetails report_page={1} report_limit={limit} report_station={""} report_job_status={""} report_date_range={searchedData?.date_range} report_hour_count={searchedData?.hour_count} user={row.data.status} />}</pre>;


  const handleRowExpand = useCallback((row) => {
    const omit =['hour_count']
    const unmatchedkey = getUnmatchedKeys(searchedData, searchFormik.values,omit)
    if (unmatchedkey.length > 0) {
      handleModalShow()
    }
    else {
    setColorRow(row);
    const isRowExpanded = expandedRows.includes(row);
    setExpandedRows(isRowExpanded ? expandedRows.filter((r) => r !== row) : [row]);
      }
  });

  const searchFormik = useFormik({
    initialValues: {
      search: "",
      job_status: "",
      station: "",
      date_range:  [startOfMonth(new Date().setHours(0, 0, 0, 0)), new Date().setHours(23, 59, 59, 59)],
      created_date:  `${moment(startOfMonth(new Date().setHours(0, 0, 0, 0))).format('MM/DD/YYYY HH:mm:ss')} - ${moment(new Date().setHours(23, 59, 59, 59)).format('MM/DD/YYYY HH:mm:ss')}`,
      hour_count: "true",
      users_ids: [],
      clients: [],
      facilities: [],
      partners: []

    },
    validate: (value) => {
      console.log(value);
      const errors = {};
      if (!value?.date_range?.length > 0 && !value?.created_date.length > 0) {
        errors.date_range = "Required";
        errors.created_date = "Required";
      }
      return errors;
    },
    onSubmit: (values) => {
      setIsInitSearch(false)
      // values.users_ids = values?.users_ids.length > 0 ? values?.users_ids.map((i) => i?.value) : []
      const client_ids = selectValue?.map(i => i.value)
      const facility_ids = selectedFacility?.map(i => i.value)
      const partner_ids = selectedPartner?.map(i => i.value)
      values.clients = client_ids
      values.facilities = facility_ids
      values.partners = partner_ids
      searchData(values)
      setSearchedData({
        search: values?.search ? values?.search : "",
        job_status: values?.job_status ? values?.job_status : "",
        station: values?.station ? values?.station : "",
        date_range: values.created_date,
        users_ids: values?.users_ids,
        hour_count: values?.hour_count ? values?.hour_count : "",
        clients: values?.clients ? values?.clients : "",
        facilities: values?.facilities ? values?.facilities : "",
        partners: values?.partners ? values?.partners : "",
      })
      handleResetDataTable()
    }
  })
  const handleModalOk =  () => {
    // Call the API here
      handleModalClose()
       searchFormik.handleSubmit() 
     
  };

  const columns = useMemo(
    () => [
      {
        id: 'S.NO',
        name: 'S.NO',
        selector: (row, index) => pageno == 1 ? index + 1 : (pageno - 1) * limit + index + 1,
        wrap: true,
        width: "40px",
        grow: 0,

      },
      {
        id: 'USER',
        name: 'USER NAME',
        selector: row => row?.username,
        cell: (row) =>
          <div>
            {row?.username &&

              <div onClick={() => handleRowExpand(row)} className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ maxWidth: '110px' }}>
                <div className='overflow-hidden text-truncate' style={{ maxWidth: "110px" }} >
                  <Tooltip disableInteractive title={row?.username} placement="top" arrow>
                    <span className="text-truncate" > {row?.username}</span>
                  </Tooltip>
                </div>
              </div>

            }
          </div>
        ,


        left: true,
        wrap: true,
        reorder: false,
        grow: 0,
        expandOnRowClicked: true,
        minWidth: '120px'


      },
      {
        id: 'PARTNER NAME',
        name: 'PARTNER NAME',
        selector: row => row?.partner_name,
        cell: (row) =>
          <div>
            {row?.partner_name &&

              <div onClick={() => handleRowExpand(row)} className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ maxWidth: '110px' }}>
                <div className='overflow-hidden text-truncate' style={{ maxWidth: "110px" }} >
                  <Tooltip disableInteractive title={row?.partner_name} placement="top" arrow>
                    <span className="text-truncate" > {row?.partner_name}</span>
                  </Tooltip>
                </div>
              </div>

            }
          </div>
        ,
        left: true,
        wrap: true,
        reorder: false,
        grow: 0,
        expandOnRowClicked: true,
        minWidth: '120px'
      },
      {
        id: 'CLIENT NAME',
        name: 'CLIENT NAME',
        selector: row => row?.client_name,
        cell: (row) =>
          <div>
            {row?.client_name &&

              <div onClick={() => handleRowExpand(row)} className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ maxWidth: '110px' }}>
                <div className='overflow-hidden text-truncate' style={{ maxWidth: "110px" }} >
                  <Tooltip disableInteractive title={row?.client_name} placement="top" arrow>
                    <span className="text-truncate" > {row?.client_name}</span>
                  </Tooltip>
                </div>
              </div>

            }
          </div>
        ,
        left: true,
        wrap: true,
        reorder: false,
        grow: 0,
        expandOnRowClicked: true,
        minWidth: '120px'
      },
      {
        id: 'FACILITY NAME',
        name: 'FACILITY NAME',
        selector: row => row?.facility_name,
        cell: (row) =>
          <div>
            {row?.facility_name &&

              <div onClick={() => handleRowExpand(row)} className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ maxWidth: '110px' }}>
                <div className='overflow-hidden text-truncate' style={{ maxWidth: "110px" }} >
                  <Tooltip disableInteractive title={row?.facility_name} placement="top" arrow>
                    <span className="text-truncate" > {row?.facility_name}</span>
                  </Tooltip>
                </div>
              </div>

            }
          </div>
        ,


        left: true,
        wrap: true,
        reorder: false,
        grow: 0,
        expandOnRowClicked: true,
        minWidth: '120px'


      },
      {
        id: 'TOTAL JOB',
        name: 'TOTAL JOB',
        selector: row => row?.total_jobs,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.total_jobs}</span>,

        right: true,
        wrap: true,
        reorder: false,
        omit: searchedData.station == 2 ? true : false,
        minWidth: '50px'

      },
      {
        id: 'CLMS',
        name: 'CLMS',
        selector: row => row?.claims,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.claims}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0,
        minWidth: '50px'


      },
      {
        id: 'QA',
        name: 'QA',
        selector: row => row?.qa_complete,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.qa_complete}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0,
        minWidth: '50px',
        maxWidth: '50px'

      },
      {
        id: 'ERROR COUNT',
        name: 'ERROR COUNT',
        selector: row => row?.error_count,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.error_count}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0,
        minWidth: '90px'

      },
      {
        id: 'NO.OF ERROR FIELDS',
        name: 'NO.OF ERROR FIELDS',
        selector: row => row?.error_fields,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.error_fields}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0,
        minWidth: '120px'

      },

      {
        id: 'TOTAL FIELDS',
        name: 'TOTAL FIELDS',
        selector: row => row?.total_fields_count,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.total_fields_count}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0,
        minWidth: '50px'

      },
      {
        id: 'QUALITY',
        name: 'QUALITY %',
        selector: row => row?.quality,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.quality}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0,
        minWidth: '50px'

      },

      {
        id: 'ERROR FIELDS QALITY',
        name: 'ERROR FIELDS QALITY %',
        selector: row => row?.error_field_quality,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.error_field_quality}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0,
        minWidth: '120px'

      },
      {
        id: 'QA TIME',
        name: 'QA TIME',
        selector: row => row?.qa_time,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.qa_time}</span>,

        left: true,
        wrap: true,
        reorder: false,
        omit: searchedData.station != 2 ? true : false,
        minWidth: '60px',
        maxWidth: '60px'

      },
      {
        id: 'CPH',
        name: 'CPH',
        selector: row => row?.qa_cph,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.qa_cph}</span>,

        right: true,
        wrap: true,
        reorder: false,
        omit: searchedData.station != 2 ? true : false,
        minWidth: '50px'

      },
      {
        id: 'REASSIGN',
        name: 'REASSIGN',
        selector: row => row?.re_assigned,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.re_assigned}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0,
        minWidth: '50px'

      },

      {
        id: 'CLM DEL',
        name: 'CLM DEL',
        selector: row => row?.claims_delete,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.claims_delete}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0,
        minWidth: '50px'


      },

      {
        id: 'SVC LINE DEL',
        name: 'SVC LINE DEL',
        selector: row => row?.servicelines_delete,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.servicelines_delete}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0,
        minWidth: '80px'

      },

      {
        id: 'PLB DELETE',
        name: 'PLB DELETE',
        selector: row => row?.plb_delete,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.plb_delete}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0,
        minWidth: '50px'

        // omit: isTimeCount
      },
      {
        id: 'TRNS TYPE CHANGED',
        name: 'TRNS TYPE CHANGED',
        selector: row => row?.transaction_types,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.transaction_types}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0,
        width: '120px'
      },
      {
        id: '837 ERROR',
        name: '837 ERROR',
        selector: row => row?.is_837_error,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.is_837_error}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        width: '100px'
      },
       {
        id: 'claims_error',
        name: 'CLM ERROR',
        selector: row => row?.is_claims_error,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.is_claims_error}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0,
        width: '100px'
      },

    ],

    [handleRowExpand, limit, pageno],
  );

  var i = 0;
  const conditionalRowStyles = [

    {
      when: row => colorRow.id == row.id ? true : false,
      style: (row, index) => ({
        backgroundColor: colorRow?.id == row.id ? '#dbf4f5' : '#f2f2f2',
        color: 'black',
        // fontWeight: '550'
      }),
    },


  ];
  const handleRowClick = (row) => {
  
    const omit =['hour_count']
    const unmatchedkey = getUnmatchedKeys(searchedData, searchFormik.values,omit)
    if (unmatchedkey.length > 0) {
      handleModalShow()
    }
    else {  // setExpandedRows([])
    // setColorRow(row);
    setColorRow(row);
    const isRowExpanded = expandedRows.includes(row);
    setExpandedRows(isRowExpanded ? expandedRows.filter((r) => r !== row) : [row]);
    }
  };



  const [datetime, setDateTime] = useState([]);

  const handleOnDateTimeChange = ({ name, value }) => {
    setExpandedRows([])
    let created_date = ""
    if (value !== null) {
      const startDate = value[0];
      const endDate = value[1];
      // Check if the start date is after the end date, and swap the dates if needed
      let isGreater = false
      if (startDate > endDate) {
        isGreater = true
      }
      const datefrom = moment(isGreater ? endDate : startDate).format('MM/DD/YYYY HH:mm:ss')
      const dateto = moment(isGreater ? startDate : endDate).format('MM/DD/YYYY HH:mm:ss')

      created_date = datefrom + " - " + dateto
    } else {
      setSearchedData({
        ...searchedData,
        created_date: "",
        date_range: "",
      })
      fetchData(1, limit, searchedData?.station, selectValue, "", searchedData?.hour_count, searchedData.users_ids, searchedData?.clients, searchedData.facilities, searchedData?.partners);

    }

    setDateTime(created_date)

    searchFormik.setValues({ ...searchFormik.values, created_date, date_range: value ?? "" })


  }

  const searchData = ({ station, job_status, created_date, hour_count, users_ids, clients, facilities,partners }) => {
    fetchData(1, limit, station, '', created_date, hour_count, users_ids, clients, facilities,partners)
  }


  const showTooltip = (text, props) => (
    <Tooltip id="button-tooltip" {...props}>
      {text}
    </Tooltip>
  );


  const handleResetDataTable = () => {
    setRerenderDataTable(true)
    // setTimeout(() => {
    //   setRerenderDataTable(false)
    // }, 200);
  }

  const [loader, setLoader] = useState(false);
  const [staffList, setStaffList] = useState([]);
  const [isFocusedStaff, setIsFocusedStaff] = useState(false);
  const [selectStaffValue, setSelectStaffValue] = useState([])


  const handleDownload = (type = 'summury') => {
    setLoader(true)
    const client_ids = selectValue?.map(i => i.value)
    const facility_ids = selectedFacility?.map(i => i.value)
    const partner_ids = selectedPartner?.map(i => i.value)
    if (type === 'field_error') {
      downloadQaErrorFieldReport(1, limit, searchFormik.values?.station, '', searchFormik.values?.created_date, searchFormik.values?.hour_count, searchFormik.values?.users_ids, client_ids, facility_ids,partner_ids).then((response) => {
        setLoader(false)
        downloadXl(response?.data?.export_file)
      });
    }
    else if (type === 'quality_report') {
      downloadQualityReport(1, limit, searchFormik.values?.station, '', searchFormik.values?.created_date, searchFormik.values?.hour_count, searchFormik.values?.users_ids, client_ids, facility_ids).then((response) => {
        setLoader(false)
        downloadXl(response?.data?.export_file)
      }).catch(() => setLoader(false));
    }
    else if (type === 'summury') {
      downloadQaErrorReportSummery(1, limit, searchFormik.values?.station, '', searchFormik.values?.created_date, searchFormik.values?.hour_count, searchFormik.values?.users_ids, client_ids, facility_ids,partner_ids).then((response) => {
        setLoader(false)
        downloadXl(response?.data?.export_file)
      });
    }
    else {
      downloadQaErrorReportSingle(1, limit, searchFormik.values?.station, '', searchFormik.values?.created_date, searchFormik.values?.hour_count, searchFormik.values?.users_ids, client_ids, facility_ids, partner_ids).then((response) => {
        setLoader(false)
        downloadXl(response?.data?.export_file)
      });
    }
  }
  useEffect(() => {
    searchFormik.validateForm()
    // fetchData(1, limit, searchedData?.station, '', searchedData?.date_range, searchedData?.hour_count, searchedData.users_ids, '', '');
    getPartnerDropdown().then((response) => {
      if (response?.status) {
        setPartners(response?.data)
        getClientPartnerDropdown(response?.data?.map(i => i.value)).then((response) => {
          if (response?.status) {
            const data = response?.data?.partners
            const clientIdArr = []
            const FullClients = []
            setClients(data?.map(result => {
              result?.clients?.map(item => clientIdArr.push(item.value));
              FullClients.push({ options: result?.clients, label: result?.partner, id: result?.pk })
              return { options: result?.clients, label: result?.partner, id: result?.pk }

            }))
            setFullClients(FullClients)

            getFacilityDropdown(clientIdArr).then((response) => {
              if (response && response.status) {
                const feciltyIdArr = []
                const FullFacilities = []
                setFacilities(response.data.facilities?.map(result => {
                  result?.facilities?.map(item => feciltyIdArr.push(item.value));
                  FullFacilities.push({ options: result?.facilities, label: result?.client, id: result?.pk })
                  return { options: result?.facilities, label: result?.client, id: result?.pk }

                }))

                setFullFacilities(FullFacilities)
                const newArray = selectedFacility.filter(item => feciltyIdArr.includes(item.value));
                setSelectedFacility(newArray)
              }
            });
          }
        })

      }
    })
    getUserlist(1).then((response) => {
      if (response && response.status && response.data && response.data.results) {
        setStaffList(response.data.results)

      }
    });
  }, [])
  
  useEffect(()=>{
  
    const client_ids = selectValue?.map(i => i.value)
    const facility_ids = selectedFacility?.map(i => i.value)
    const partner_ids = selectedPartner?.map(i => i.value)
    searchFormik.setValues({...searchFormik.values,clients: client_ids,facilities:facility_ids,partners:partner_ids})


},[selectedFacility,selectValue,selectedPartner])




  const setFacilityOptions = (clientId) => {
    getFacilityDropdown(clientId).then((response) => {
      if (response && response.status) {
        setFacilities(response.data.facilities?.map(result => {
          return { options: result?.facilities, label: result?.client }

        }))

      }
    });
  }
  const [fullFacilities, setFullFacilities] = useState([])

  const checkSelectedFecilityInitialClient = (selectedOptions) => {

    // Initialize an empty result array and a set to track unique labels
    var result = [...selectValue];
    var uniqueLabels = new Set();
    const clientId = selectValue?.map((value) => String(value?.value))

    // Loop through selected options
    for (var i = 0; i < selectedOptions.length; i++) {
      var selectedOption = selectedOptions[i];

      // Loop through the list of dictionaries to find matching options
      for (var j = 0; j < fullFacilities.length; j++) {
        var options = fullFacilities[j].options;
        for (var k = 0; k < options.length; k++) {
          if (options[k].value === selectedOption.value && options[k].label === selectedOption.label) {
            // Check if the label is unique before adding it to the result
            console.log(clientId, fullFacilities[j].id)
            if (!uniqueLabels.has(fullFacilities[j].label) && !clientId.includes(String(fullFacilities[j].id))) {
              result.push({
                "value": Number(fullFacilities[j].id),
                "label": fullFacilities[j].label,
              });
              uniqueLabels.add(fullFacilities[j].label);
            }
            break;
          }
        }
      }
    }
    console.log("Result:", result);
    return result
  }
  // const handleSelectChange = (val, name = null) => {
  //   console.log(val)
  //   let selectedOptions = [];
  //   let selectedIds = [];

  //   if (val && val?.length > 0) {

  //     val?.map((option) => {
  //       selectedIds.push(option.value)
  //       selectedOptions.push(option)
  //     })

  //   } else {

  //     setSelectedFacility([])
  //     setSelectedFacilityIds([])
  //   }

  //   if (name == "facility") {
  //     const initiaClientsOptions = checkSelectedFecilityInitialClient(selectedOptions)
  //     // const clientIds = initiaClientsOptions?.map((value) => value?.value)
  //     setSelectedFacility(selectedOptions)
  //     setSelectedFacilityIds(selectedIds)
  //     setSelectValue(initiaClientsOptions)
  //     // setFacilityOptions(clientIds)
  //   } else {
  //     // setClients(val.includes('all') ? ['all'] : selectedId)
  //     if (!(val && val?.length > 0)) {
  //       if (clients && clients.length > 0) {
  //         const clientId = clients?.map((value) => value?.value)
  //         setFacilityOptions(clientId)
  //       }

  //     } else {
  //       getFacilityDropdown(selectedIds).then((response) => {
  //         if (response && response.status) {
  //           const feciltyIdArr = []
  //           setFacilities(response.data.facilities?.map(result => {
  //             console.log(result?.facilities, 'EEEEE')
  //             result?.facilities?.map(item => feciltyIdArr.push(item.value));
  //             return { options: result?.facilities, label: result?.client }

  //           }))

  //           const newArray = selectedFacility.filter(item => feciltyIdArr.includes(item.value));
  //           setSelectedFacility(newArray)
  //         }
  //       });

  //     }

  //     setSelectValue(selectedOptions)
  //     setSelectIds(selectedIds)
  //     // setSelectedFacility([])
  //   }
  // };
  const handleSelectChange = (val, name = null) => {
    let selectedOptions = [];
    let selectedIds = [];
    if (val && val?.length > 0) {

      val?.map((option) => {
        selectedIds.push(option.value)
        selectedOptions.push(option)
      })
    }
    if (name == 'facility') {
      setSelectedFacility(selectedOptions)
      setSelectedFacilityIds(selectedIds)
    }
    else if (name == 'client') {
      setSelectedFacility([])
      setFacilities([])
      setSelectValue(selectedOptions)
      setSelectIds(selectedIds)
      const feciltyIdArr = []
      console.log(clients)
      let clientoptions = []
      clients?.map(client => {
        client?.options?.map(item => {
          clientoptions.push(item?.value)
        })
      })
      getFacilityDropdown(selectedIds?.length ? selectedIds : clientoptions).then((response) => {
        if (response && response.status) {
          setFacilities(response.data.facilities?.map(result => {
            result?.facilities?.map(item => feciltyIdArr.push(item.value));
            return { options: result?.facilities, label: result?.client }

          }))
          const newArray = selectedFacility.filter(item => feciltyIdArr.includes(item.value));
          setSelectedFacility(selectedIds?.length ? newArray : [])
        }
      });
    }
    else if (name == 'partner') {
      setSelectedPartner(selectedOptions)
      setSelectedFacility([])
      setFacilities([])
      setClients([])
      setSelectValue([])
      searchFormik.setFieldValue("partners", selectedIds)
      getClientPartnerDropdown(selectedIds?.length ? selectedIds : null).then((response) => {
        if (response?.status) {

          const data = response?.data?.partners
          const clientIdArr = []
          setClients(data?.map(result => {
            result?.clients?.map(item => clientIdArr.push(item.value));
            return { options: result?.clients, label: result?.partner, id: result?.pk }
          }))
          const newArray = selectValue.filter(item => clientIdArr.includes(item.value));
          setSelectValue(selectedIds?.length ? newArray : [])
          let clientIds = []
          newArray?.map((item) => {
            clientIds.push(item.value)
          })
          getFacilityDropdown(selectedIds?.length && clientIds?.length ? clientIds : clientIdArr).then((response) => {
            if (response && response.status) {
              const feciltyIdArr = []
              setFacilities(response.data.facilities?.map(result => {
                result?.facilities?.map(item => feciltyIdArr.push(item.value));
                return { options: result?.facilities, label: result?.client, id: result?.pk }

              }))
              const newArray = selectedFacility.filter(item => feciltyIdArr.includes(item.value));
              setSelectedFacility(selectedIds?.length ? newArray : [])

            }
          });
        }
      })
    }
  }
  const DropdownIndicator = ({ state, ...props }) => {
    console.log(state?.length, state)
    return (
      <components.DropdownIndicator {...props}>

        {state?.length > 1 ? (
          <TbGridDots style={{ fontSize: "1.5em" }} />
        ) : (
          <HiChevronDown style={{ fontSize: "1.5em" }} />
        )}



      </components.DropdownIndicator>
    );
  };
  return (
    <React.Fragment>
      {/* <Header /> */}
      <Sidebar />
      <main id="main" className="main">

        <div className="pagetitle tab-fixed-header">
          <h1 id='page-title'>QA Report</h1>
        </div>

        <section className="section mt-5 ">
          <div className="row align-items-top py-2 gap-2 gap-md-5">
            <div className="col-lg-12">
              <div className="card mb-5 mb-xl-8 " style={{ height: "92vh" }}>

                <Form onSubmit={searchFormik.handleSubmit} >
                  <div className=" ">
                    <div className="px-1 py-1 d-flex flex-row justify-content-start gap-2 align-items-center flex-wrap">

                      {/* <div className='col-md-2' >
                        <AsyncSelect
                          // cacheOptions
                          placeholder="Select Users"
                          tabSelectsValue={false}
                          isMulti
                          loadOptions={loadOptions}
                          defaultOptions={[]}
                          className="basic-single"
                          classNamePrefix="select"
                          isClearable={true}
                          onChange={(e) => handleOnSelectChange(e, 'payer_id')}
                        // debounceInterval={1000}
                        />

                      </div> */}
                      <div>
                        <Select
                          isMulti
                          tabSelectsValue={false}
                          closeMenuOnSelect={false} // Keep the menu open after selecting an option
                          hideSelectedOptions={false}
                          options={staffList}
                          className="select-search-835-list"
                          // formatOptionLabel={formatOptionLabel}
                          components={{ DropdownIndicator: (props) => <DropdownIndicator {...props} state={searchFormik?.values?.staff} /> }}
                          classNamePrefix="select"
                          placeholder="Users"
                          // values={selectValue}
                          menuPlacement="auto"
                          maxMenuHeight={300}
                          isClearable
                          name="staff"
                          onFocus={() => setIsFocusedStaff(true)}
                          onBlur={() => setIsFocusedStaff(false)}
                          onChange={(e) => {
                            searchFormik.setFieldValue("users_ids", e.map(i => i.value))
                          }}
                          // value={status.filter((item) => jobStatus?.includes(item.value))}
                          styles={{
                            container: (styles, state) => ({
                              ...styles,
                              borderRadius: "9px",
                            }),
                            control: (styles, state) => ({
                              ...styles,
                              backgroundColor: "hsl(204deg 33.33% 97.06%)",
                              borderStyle: "none", boxShadow: "none",
                              borderRadius: "10px",
                              maxHeight: "30px",
                            }),
                            indicatorSeparator: styles => ({
                              ...styles, width: "0px", minHeight: "20px",
                              maxHeight: "30px",
                            }),

                            valueContainer: (styles, state) => ({
                              ...styles,
                              maxHeight: "30px",
                              overflow: 'scroll',
                            }),
                            option: (styles, state) => ({
                              ...styles,
                              backgroundColor: state.isSelected ? '#d9f4f5' : 'inherit',
                              color: state.isSelected ? '#000000' : 'inherit',
                              '&:hover': { backgroundColor: state.isSelected ? '#d9f4f5' : 'rgb(222, 235, 255)' }

                            })
                          }} />
                      </div>
                      <div>
                        <Select
                          options={partners}
                          className=""
                          classNamePrefix="select"
                          placeholder="Partner"
                          menuPlacement="auto"
                          maxMenuHeight={300}
                          isClearable
                          isMulti
                          name="partners"
                          tabSelectsValue={false}
                          onChange={(val) => {
                            handleSelectChange(val, 'partner')
                          }}
                          onFocus={() => setIsFocusedPartner(true)}
                          onBlur={() => setIsFocusedPartner(false)}
                          value={selectedPartner}
                          components={{ DropdownIndicator: (props) => <DropdownIndicator {...props} state={selectedPartner} /> }}
                          hideSelectedOptions={false}
                          styles={{
                            container: (styles, state) => ({
                              ...styles,
                              borderRadius: "9px",
                            }),
                            control: (styles, state) => ({
                              ...styles,
                              backgroundColor: "hsl(204deg 33.33% 97.06%)",
                              borderStyle: "none", boxShadow: "none",
                              borderRadius: "10px",
                              maxHeight: "30px",
                            }),
                            indicatorSeparator: styles => ({
                              ...styles, width: "0px",
                              minHeight: "20px",
                              maxHeight: "30px",
                            }),

                            valueContainer: (styles, state) => ({
                              ...styles,
                              maxHeight: "30px",
                              overflow: 'scroll',
                            }),
                            option: (styles, state) => ({
                              ...styles,
                              backgroundColor: state.isSelected ? '#d9f4f5' : 'inherit',
                              color: state.isSelected ? '#000000' : 'inherit',
                              '&:hover': { backgroundColor: state.isSelected ? '#d9f4f5' : 'rgb(222, 235, 255)' }

                            })
                          }}
                          menuPortalTarget={document.body}
                          closeMenuOnSelect={false} // Keep the menu open after selecting an option

                        />
                      </div>
                      <div>
                        <Select
                          ref={clientRef}
                          tabSelectsValue={false}
                          isMulti
                          options={clients}
                          value={selectValue}
                          className=""
                          classNamePrefix="select"
                          placeholder="Client"
                          menuPlacement="auto"
                          maxMenuHeight={300}
                          isClearable
                          name="client"
                          onChange={(val) => handleSelectChange(val, 'client')}
                          components={{ DropdownIndicator: (props) => <DropdownIndicator {...props} state={selectValue} /> }}
                          hideSelectedOptions={false}
                          onFocus={() => setIsFocusedClient(true)}
                          onBlur={() => setIsFocusedClient(false)}
                          styles={{
                            container: (styles, state) => ({
                              ...styles,
                              borderRadius: "9px",
                            }),
                            control: (styles, state) => ({
                              ...styles,
                              backgroundColor: "hsl(204deg 33.33% 97.06%)",
                              borderStyle: "none", boxShadow: "none",
                              borderRadius: "10px",
                              maxHeight: "30px",
                            }),
                            indicatorSeparator: styles => ({
                              ...styles, width: "0px",
                              minHeight: "20px",
                              maxHeight: "30px",
                            }),

                            valueContainer: (styles, state) => ({
                              ...styles,
                              maxHeight: "30px",
                              overflow: 'scroll',
                            }),
                            option: (styles, state) => ({
                              ...styles,
                              backgroundColor: state.isSelected ? '#d9f4f5' : 'inherit',
                              color: state.isSelected ? '#000000' : 'inherit',
                              '&:hover': { backgroundColor: state.isSelected ? '#d9f4f5' : 'rgb(222, 235, 255)' }

                            })
                          }}
                          menuPortalTarget={document.body}
                          closeMenuOnSelect={false} // Keep the menu open after selecting an option

                        />
                      </div>
                      <div>
                        <Select
                          ref={facilityRef}
                          options={facilities}
                          className=""
                          classNamePrefix="select"
                          placeholder="Facility"
                          menuPlacement="auto"
                          maxMenuHeight={300}
                          isClearable
                          isMulti
                          name="facility"
                          value={selectedFacility}
                          components={{ DropdownIndicator: (props) => <DropdownIndicator {...props} state={selectedFacility} /> }}
                          hideSelectedOptions={false}
                          tabSelectsValue={false}

                          onChange={(val) => handleSelectChange(val, 'facility')}
                          onFocus={() => setIsFocusedFacility(true)}
                          onBlur={() => setIsFocusedFacility(false)}

                          styles={{
                            container: (styles, state) => ({
                              ...styles,
                              borderRadius: "9px",
                            }),
                            control: (styles, state) => ({
                              ...styles,
                              backgroundColor: "hsl(204deg 33.33% 97.06%)",
                              borderStyle: "none", boxShadow: "none",
                              borderRadius: "10px",
                              maxHeight: "30px",
                            }),
                            indicatorSeparator: styles => ({
                              ...styles, width: "0px",
                              minHeight: "20px",
                              maxHeight: "30px",
                            }),

                            valueContainer: (styles, state) => ({
                              ...styles,
                              maxHeight: "30px",
                              overflow: 'scroll',
                            }),
                            option: (styles, state) => ({
                              ...styles,
                              backgroundColor: state.isSelected ? '#d9f4f5' : 'inherit',
                              color: state.isSelected ? '#000000' : 'inherit',
                              '&:hover': { backgroundColor: state.isSelected ? '#d9f4f5' : 'rgb(222, 235, 255)' }

                            })
                          }}
                          menuPortalTarget={document.body}
                          closeMenuOnSelect={false} // Keep the menu open after selecting an option

                        />
                      </div>
                      <div className='small-select-station'>

                        <SingleSelect is_clear={true} formik={searchFormik} placeholder="Station" name="station" list={station_option} />

                      </div>
                      <Tooltip disableInteractive title={"Processed Date"} placement="top" arrow>
                      <div className= {`${searchFormik.errors.date_range ? "date-range-pickr-error ":""}  correspondenceDatePicker"`}>
                          <Stack direction="column" spacing={8} alignItems="flex-start">

                            <DateRangePicker
                              ranges={predefinedBottomRanges}
                              cleanable={false}
                              placement="auto"
                              appearance="default" format={"MM/dd/yyyy HH:mm:ss"}
                              className="form-date-control form-control-solid b-r-1 text-dark"
                              placeholder={"MM/DD/YYYY - MM/DD/YYYY"}
                              name="date_range"
                              onChange={(e) => { handleOnDateTimeChange({ name: 'date_range', value: e }) }} value={searchFormik?.values?.date_range} />
                          </Stack>
                        </div>
                      </Tooltip>

                      <div>
                        <Tooltip disableInteractive title={"Search"} placement="top" arrow>
                          <Button className="btn btn-light btn-active-primary" type="submit">
                            <span className="svg-icon svg-icon-3">
                              <BiSearch />
                            </span>

                          </Button>
                        </Tooltip>
                      </div>
                      {isHavePermission("export_qa_error_report_management") &&
                        // <div>
                        //   <Tooltip disableInteractive title={"Download"} placement="top" arrow>
                        //     {!loader ?
                        //       <Button onClick={() => { handleDownload() }} className="btn btn-light btn-active-primary" >
                        //         <span className="svg-icon svg-icon-3">
                        //           <BsCloudDownloadFill />
                        //         </span>

                        //       </Button> :
                        //       <Button className="btn btn-light btn-active-primary" >
                        //         <span className="svg-icon svg-icon-3">
                        //           <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        //         </span>

                        //       </Button>}
                        //   </Tooltip>

                        // </div>
                        <DownloadDropDown is_field_error={true} is_quality_report={searchFormik.values?.station == 2} loader={loader} handleDownload={handleDownload}  isDisabled={searchFormik.errors.date_range}/>

                      }

                    </div>
                  </div>

                </Form>


                <div className="card-body p-common">
                  <div className="table-responsive">
                    <div className="dashboardtable">
                      {/* {!reRenderDataTable && */}
                      <DataTable
                        className="custom-datatable"
                        paginationDefaultPage={pageno}

                        fixedHeader={true}
                        progressPending={loading}
                        data={data?.results}
                        columns={columns}
                        pointerOnHover={true}
                        pagination
                        paginationServer
                        onRowClicked={handleRowClick}
                        // highlightOnHover
                        paginationTotalRows={totalRows}
                        paginationPerPage={limit}
                        paginationRowsPerPageOptions={[25, 50, 100, 150, 200]}
                        onChangeRowsPerPage={handlePerRowsChange}
                        onChangePage={handlePageChange}
                        conditionalRowStyles={conditionalRowStyles}
                        theme="solarized"
                        customStyles={datatableCustomStyles}
                        striped={true}
                        expandableRows
                        expandOnRowClicked={false}
                        onRowExpandToggled={handleRowExpand}
                        expandableRowsComponent={ExpandedComponent}
                        expandableRowsHideExpander
                        expandableRowExpanded={(row) => expandedRows.includes(row)}
                        noDataComponent={isInitSearch ?<p className="p-4">Apply filters to refine and display the data</p> :<p className="p-4">There are no records to display</p>} 


                      />
                      {/* } */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FilterUnMatchModal
          show={unmatchFilterModalShow}
          handleClose={handleModalClose}
          handleModalOk={handleModalOk}
        />

      </main>
    </React.Fragment >
  )
}
export default QaErrorReport




